
import { UseFormReturn } from "react-hook-form";
import { ProfileFormData } from "../types";
import { BioField } from "./fields/BioField";
import { LocationFields } from "./fields/LocationFields";
import { LanguagesField } from "./fields/LanguagesField";
import { HostingStyleField } from "./fields/HostingStyleField";
import { SpecialtiesField } from "./fields/SpecialtiesField";
import { NationalityField } from "./fields/NationalityField";

interface FormFieldsProps {
  form: UseFormReturn<ProfileFormData>;
}

export const FormFields = ({ form }: FormFieldsProps) => {
  return (
    <>
      <BioField form={form} />
      <LocationFields form={form} />
      <LanguagesField form={form} />
      <NationalityField form={form} />
      <HostingStyleField form={form} />
      <SpecialtiesField form={form} />
    </>
  );
};
